import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "confirmModal-cmp",
  templateUrl: "confirmModal.component.html",
})
export class ConfirmModalComponent implements OnInit {
  @Input() confirmValues: any;
  test: Date = new Date();
  commentForm : FormGroup;
  submitted = false;
  constructor(public dialogRef: NgbActiveModal,public fb : FormBuilder) {
    this.commentForm = this.fb.group({
      comment: [""],
    });
  }
  ngOnInit() {
   console.log(this.confirmValues)
   if(this.confirmValues?.comment){
    this.commentForm.controls['comment'].setValidators([Validators.required])
   }
   this.commentForm.controls['comment'].updateValueAndValidity()

  }
  close() {
    this.dialogRef.close({ success: false });
  }
  get f(){
    return this.commentForm.controls;
  }
  confirm() {
    this.submitted = true;
    if(this.confirmValues.comment){
      if(this.commentForm.invalid){
        return;
      }
      this.dialogRef.close({ success: true,data : this.commentForm.value });
    }else{
    this.dialogRef.close({ success: true });
    }
  }
}
